import { render } from "./ThankYouModal.vue?vue&type=template&id=45c47007"
import script from "./ThankYouModal.vue?vue&type=script&lang=js"
export * from "./ThankYouModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__